// Consent-gated analytics loader with per-category control.
// - Analytics category  -> Google Analytics 4
// - Marketing category   -> Meta (Facebook) Pixel
// Necessary cookies are always allowed. Nothing third-party loads without consent.
// IDs come from env so the gate stays dormant until configured.

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
const CONSENT_KEY = 'riq_cookie_consent';

let gaLoaded = false;
let pixelLoaded = false;

const loadGA = () => {
  if (gaLoaded || !GA_ID || window.gtag) return;
  gaLoaded = true;
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_ID, { anonymize_ip: true });
};

const loadMetaPixel = () => {
  if (pixelLoaded || !PIXEL_ID || window.fbq) return;
  pixelLoaded = true;
  /* eslint-disable */
  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
  n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
  document,'script','https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
  window.fbq('init', PIXEL_ID);
  window.fbq('track', 'PageView');
};

// Returns { necessary, analytics, marketing } or null if no choice stored.
export const getStoredConsent = () => {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    // Back-compat with the old single-choice format.
    if (parsed.choice === 'all' && parsed.analytics === undefined) {
      return { necessary: true, analytics: true, marketing: true };
    }
    if (parsed.choice === 'essential_only' && parsed.analytics === undefined) {
      return { necessary: true, analytics: false, marketing: false };
    }
    return {
      necessary: true,
      analytics: !!parsed.analytics,
      marketing: !!parsed.marketing,
    };
  } catch {
    return null;
  }
};

// Load trackers according to the categories the user consented to.
export const applyConsent = (consent) => {
  if (!consent) return;
  if (consent.analytics) loadGA();
  if (consent.marketing) loadMetaPixel();
};

// Apply whatever is already stored (used on app load / return visits).
export const initAnalytics = () => applyConsent(getStoredConsent());
